export default "__VITE_ASSET__BdZ9Prjf__"